<template>
    <div>
        <div class="input-group">
            <label for="pegasus-api-url">Pegasus API URL:</label>
            <input id="pegasus-api-url" type="text" v-model="ApiURL" placeholder="Pegasus API URL girin" />
        </div>
        <div class="input-group">
            <label for="pegasus-username">Pegasus Username:</label>
            <input id="pegasus-username" type="text" v-model="Username" placeholder="Pegasus Username girin" />
        </div>
        <div class="input-group">
            <label for="pegasus-password">Pegasus Password:</label>
            <input id="pegasus-password" type="text" v-model="Password" placeholder="Pegasus Password girin" />
        </div>
        <div class="input-group">
            <label for="pegasus-invoice">Pegasus Invoice:</label>
            <input id="pegasus-invoice" type="text" v-model="Invoice" placeholder="Pegasus Invoice girin" />
        </div>
        <v-btn color="primary" class="mt-4" @click="saveProviderConfig">
            Kaydet
        </v-btn>
    </div>
</template>

<script>
export default {
    name: "PegasusProvider",
    props: {
        providerData: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            ApiURL: "",
            Username: "",
            Password: "",
            Invoice: "",
        }
    },
    watch: {
        // Üst bileşenden veri geldikçe veya sıfırlandıkça formu tetikler
        providerData: {
            handler(newValue) {
                this.fillForm(newValue);
            },
            deep: true,
            immediate: true // İlk yüklemede de çalışmasını sağlar
        }
    },
    methods: {
        fillForm(data) {
            // data doluysa ve bir Id içeriyorsa (edit modu) form alanlarını doldurur
            if (data && Object.keys(data).length > 0) {
                // API'den gelen obje yapısına göre Address, ServiceUsername vb. alanları eşleştiriyoruz
                this.ApiURL = data.Address || data.url || "";
                this.Username = data.ServiceUsername || data.username || "";
                this.Password = data.ServicePassword || data.password || "";
                this.Invoice = data.ServiceSecurityKey || data.invoice || "";
            } else {
                // Eğer data boş veya null geldiyse alanları sıfırla (add modu)
                this.ApiURL = "";
                this.Username = "";
                this.Password = "";
                this.Invoice = "";
            }
        },
        saveProviderConfig() {
            if (!this.ApiURL || !this.Username || !this.Password || !this.Invoice)
                return this.$toast.error("Lütfen tüm alanları doldurun.");

            // Gelen datada ID varsa 'edit', yoksa veya boşsa 'add' moduna geçer
            const type = this.providerData && this.providerData.Id ? 'edit' : 'add';

            const config = {
                Address: this.ApiURL,
                ServiceUsername: this.Username,
                ServicePassword: this.Password,
                ServiceSecurityKey: this.Invoice,
            }
            this.$emit("save", config, type);
        }
    }
}
</script>

<style scoped>
div {
    font-family: 'Roboto', sans-serif;
}

.input-group {
    margin-bottom: 20px;
    display: flex;
    flex-direction: column;
}

.input-group label {
    margin-bottom: 8px;
    font-weight: 500;
    color: #333;
    font-size: 14px;
}

.input-group input {
    padding: 10px 12px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 14px;
    transition: all 0.3s ease;
}

.input-group input:focus {
    outline: none;
    border-color: #1976d2;
    box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.1);
}

.input-group input::placeholder {
    color: #999;
}

.mt-4 {
    margin-top: 16px;
    padding: 10px 24px;
    font-size: 14px;
    font-weight: 500;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.2s ease;
}
</style>